/**
 * Converts bracket notation to plain dot notation
 *
 * @example test[0][2] => test.0.2
 *
 * @param {string} path
 *
 * @return {string}
 */
export var convertBracketNotationToDots = function (path) { return (path.indexOf('[') === -1
    ? path
    : path.replace(/\[([^\]]+)\]/g, '.$1')); };
//# sourceMappingURL=convertBracketNotationToDots.js.map